import { getACHAuthorizationRecords } from './GetACHAuthorizationRecords';
import { revokeACHAuthorization } from './RevokeACHAuthorization';
import { downloadACHAuthorizationRecord } from './DownloadACHAuthorizationRecord';

export const PaymentsService = {
  getACHAuthorizationRecords,
  revokeACHAuthorization,
  downloadACHAuthorizationRecord,
};
